import React, { useState } from "react";
import { Card, CardBody, CardFooter, Row, Col, Input, FormGroup, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import cancelIcon from 'assets/icon/cancel-icon.svg';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { dateFormate } from 'utils/columns';
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";

const ViewConfigurations = ({ rowData, setOpenView }) => {
    const [data, setData] = useState(rowData);
    const [isShow, setIsShow] = useState(false);
    const [pharmacyShow, setPharmacyShow] = useState(false);
    const [planShow, setPlanShow] = useState(false);

    const shouldHighlightTitle = (data) => {
            return (data.bin.length > 1 || data.pcn.length > 1 || data.groupNumber.length > 1);
    };

    const transformData = (data) => {
        const transformed = [];
            const maxLength = Math.max(data.bin.length, data.pcn.length, data.groupNumber.length);
            for (let i = 0; i < maxLength; i++) {
                transformed.push({
                    //   id: item.id,
                    bin: data.bin[i] || '',
                    pcn: data.pcn[i] || '',
                    groupNumber:data.groupNumber[i] || ''
                });
            }
        return transformed;
    };

    const transformedData = transformData(data);
    const highlightTitle = shouldHighlightTitle(data);

    const displayLimit = 1;
    const displayedManufacturers = data.reportConfigMfgMaps.slice(0, displayLimit);
    const hiddenManufacturers = data.reportConfigMfgMaps.slice(displayLimit);

    const ManufacturerData = [];
    for (let i = 0; i < data.reportConfigMfgMaps.length; i += 10) {
        ManufacturerData.push(data.reportConfigMfgMaps.slice(i, i + 10));
    }

    const displayPharmacy = data.reportConfigClientMaps.slice(0, displayLimit)
    const hiddenPharmacy = data.reportConfigClientMaps.slice(displayLimit)

    const PharmacyData = [];
    for (let i = 0; i < data.reportConfigClientMaps.length; i += 10) {
        PharmacyData.push(data.reportConfigClientMaps.slice(i, i + 10));
    }

const array=(filterData) =>{
    let count= 0
for(let i=0; i<filterData.length; i++){
 if(filterData[i] !== ''){
     count++
 }
}
return count;
}


const binCount= array(data.bin)
const pcnCount= array(data.pcn)
const groupCount= array(data.groupNumber)

    const handleDiscard = () => {
        setOpenView(false)
    }

    const handleDisplay = () => {
        setIsShow(!isShow)
    }

    const handlePharmacyDisplay = () => {
        setPharmacyShow(!pharmacyShow)
    }

    const handlePlanShow = () => {
        if (highlightTitle) {
            setPlanShow(!planShow)
        }
    }

    let mainCol = [
        {
            dataField: 'bin',
            text: 'Bin',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.bin == ''?"-": row.bin),
        },
        {
            dataField: 'pcn',
            text: 'PCN',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.pcn == '' ?'-':row.pcn),
        },
        {
            dataField: 'groupNumber',
            text: 'Group',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.groupNumber == '' ?'-':row.groupNumber),
        },
    ]

    return (
        <>
            <Card className="border-0 shadow-top off" size="xl">
                <div>
                    <CardBody>
                        <div className='view-step-content'>
                            <div className="d-flex justify-content-between section-devider-border">
                                <h4 className='f-15 text-primary font-weight-700'>Report Details</h4>
                            </div>
                            <Row >
                                <Col md={(data.reportTypeID === 3 || data.reportTypeID === 4) ? 4: 5}>
                               
                                    <p className="m-0 f-14 mt-3 text-muted">Application Details</p>

                                
                                    <p className="m-0 f-14 font-weight-500 mt-1">
                                     {data.applicationName}
                                    </p>
                                </Col>

                                <Col md={(data.reportTypeID === 3 || data.reportTypeID === 4) ? 4 : 5}>
                                    <p className="m-0 f-14 mt-3 text-muted">Covered Entity/OPAID </p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{data.ceName}</p>
                                </Col>
                                <Col md={(data.reportTypeID === 3 || data.reportTypeID === 4) ? 4: 5}>
                                    <p className="m-0 f-14 mt-3 text-muted">Report Name</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{data.reportName}</p>
                                </Col>

                                <Col md={(data.reportTypeID === 3 || data.reportTypeID === 4) ? 4 : 5}>
                                    <p className="m-0 f-14 mt-3 text-muted">Report Type</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{data.reportTypeName}</p>
                                </Col>
                                {(data.reportTypeID === 3 || data.reportTypeID === 4) &&
                                    <Col md="8">
                                        <p
                                            className={highlightTitle ? "hilight-title m-0 f-15 text-primary font-weight-700 mt-3" : "m-0 f-14 mt-3 text-muted"}
                                            onClick={handlePlanShow}
                                        >Plan</p>
                                            <Row>
                                                <Col md="3">
                                                    <p className="m-0 f-14 mt-1 text-muted">BIN</p>
                                                    {data.bin.length > 0 ?
                                                        <p className="m-0 f-14 font-weight-500 mt-1">
                                                            {data.bin.length > 1 ?
                                                                <div>{binCount} BINs </div>
                                                                :
                                                                <div> {data.bin}</div>}</p>
                                                        :
                                                        <p className="m-0 f-14 font-weight-500 mt-1"> - </p>
                                                    }
                                                </Col>
                                                <Col md="3">
                                                    <p className="m-0 f-14 mt-1 text-muted">PCN</p>
                                                    {data.pcn.length > 0 ?
                                                        <p className="m-0 f-14 font-weight-500 mt-1">
                                                            {data.pcn.length > 1 ?
                                                                <div>{pcnCount} PCNs </div>
                                                                : <div> {data.pcn}</div>}
                                                        </p>
                                                        :
                                                        <p className="m-0 f-14 font-weight-500 mt-1"> - </p>
                                                    }
                                                </Col>
                                                <Col md="3">
                                                    <p className="m-0 f-14 mt-1 text-muted">Group</p>
                                                    {data.groupNumber.length > 0 ?
                                                        <p className="m-0 f-14 font-weight-500 mt-1">
                                                            {data.groupNumber.length > 1 ?
                                                                <div>{groupCount} Groups </div>
                                                                : <div> {data.groupNumber}</div>}
                                                        </p>
                                                        :
                                                        <p className="m-0 f-14 font-weight-500 mt-1"> - </p>
                                                    }
                                                </Col>
                                            </Row>
                                        <Modal
                                            isOpen={planShow}
                                            toggle={handlePlanShow}
                                            centered={true}
                                            className="modalTable"
                                        >
                                            <ModalHeader className="modal-title">
                                                <div className="title-cancel-icon">
                                                    <span>Plan </span>
                                                    {/* <span><img src={cancelIcon} alt=""  onClick={handleDisplay}/></span> */}
                                                    <Button className="modal-title-close" onClick={handlePlanShow}>X</Button>
                                                </div>

                                            </ModalHeader>
                                            {/* style={{ "--column-count": ManufacturerData.length }} */}
                                            <ModalBody >

                                                <div className='table-card scroll-table position-relative border-0 rounded pt-0' fixed-height-table='fixed-height-table' >
                                                    <ReactStrapTable
                                                        id='view-table'
                                                        // id='configuration-table'
                                                        height={550}
                                                        fixedColumn
                                                        width={1200}
                                                        data={transformedData}
                                                        columns={mainCol}
                                                        hasDefaultPagination={false}
                                                    >
                                                    </ReactStrapTable>
                                                </div>
                                            </ModalBody>
                                        </Modal>
                                    </Col>
                                }
                            </Row>
                            <div className="d-flex justify-content-between section-devider-border">
                                <h4 className='f-15 text-primary font-weight-700 mt-4'>Report Configurations</h4>
                            </div>
                            <Row>
                                <Col md="3">
                                    <p className="m-0 f-14 mt-3 text-muted">Claim Type </p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{data.claimTypeDesc}</p>
                                </Col>

                                <Col md="3">
                                    <p className="m-0 f-14 mt-3 text-muted">Frequency</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{data.frequencyDesc}</p>
                                </Col>
                                {(data.reportTypeID == 1 || data.reportTypeID == 2 || data.reportTypeID == 5 || data.reportTypeID ==6 || data.reportTypeID ==7 || data.reportTypeID ==8 ) && <>
                                    <Col md="3">
                                        <p className="m-0 f-14 mt-3 text-muted">Manufacturer</p>
                                        {displayedManufacturers.map((manufacturer, index) => (
                                            <p className="m-0 f-14 font-weight-500 mt-1">
                                                {manufacturer.manufacturerName}
                                            </p>
                                        ))}
                                        <div>
                                            {hiddenManufacturers.length > 0 && (
                                                <p style={{ color: '#702C62', cursor: 'pointer', fontSize: "12px", fontWeight: "500", textDecoration: "underline", }} onClick={handleDisplay}>
                                                    +{hiddenManufacturers.length} More
                                                </p>
                                            )}
                                            <Modal

                                                isOpen={isShow}
                                                toggle={handleDisplay}
                                                centered={true}
                                                className={`dynamic-modal ${ManufacturerData.length > 4 ? 'scrollable' : ''}`}
                                                style={{ "--column-count": ManufacturerData.length }}
                                            >
                                                <ModalHeader className="modal-title">
                                                    <div className="title-cancel-icon">
                                                        <span>Manufacturer List ({data.reportConfigMfgMaps.length})</span>
                                                        {/* <span><img src={cancelIcon} alt=""  onClick={handleDisplay}/></span> */}
                                                        <Button className="modal-title-close" onClick={handleDisplay}>X</Button>
                                                    </div>

                                                </ModalHeader>
                                                <ModalBody>
                                                    <div className="columns-container">
                                                        {ManufacturerData.map((manufacturer, columnIndex) => {
                                                            const startNumber = columnIndex * 10 + 1;
                                                            return (
                                                                <div key={columnIndex} className="column" >
                                                                    {manufacturer.map((item, rowIndex) => (<>
                                                                        <div key={rowIndex} className="item-name">
                                                                            <span className="item-number">{`${startNumber + rowIndex}.`}</span>
                                                                            <span className="item-text">{item.manufacturerName}</span>
                                                                        </div>
                                                                    </>
                                                                    ))}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </ModalBody>
                                            </Modal>
                                        </div>
                                    </Col>
                                    <Col md="3">
                                        <p className="m-0 f-14 mt-3 text-muted">Pharmacy </p>
                                        {displayPharmacy.map((pharmacy, index) => (
                                            <p className="m-0 f-14 font-weight-500 mt-1">
                                                {pharmacy.phName}
                                            </p>
                                        ))}
                                        <div>
                                            {hiddenPharmacy.length > 0 && (
                                                <p style={{ color: '#702C62', cursor: 'pointer', fontSize: "12px", fontWeight: "500", textDecoration: "underline", }} onClick={handlePharmacyDisplay}>
                                                    +{hiddenPharmacy.length} More
                                                </p>
                                            )}
                                            <Modal
                                                isOpen={pharmacyShow}
                                                toggle={handlePharmacyDisplay}
                                                centered={true}
                                                className={`dynamic-modal ${PharmacyData.length > 4 ? 'scrollable' : ''}`}
                                                style={{ "--column-count": PharmacyData.length }}
                                            >
                                                <ModalHeader className="modal-title">
                                                    <div className="title-cancel-icon">
                                                        <span>Pharmacy List ({data.reportConfigClientMaps.length})</span>
                                                        {/* <span><img src={cancelIcon} alt=""  onClick={handleDisplay}/></span> */}
                                                        <Button className="modal-title-close" onClick={handlePharmacyDisplay}>X</Button>
                                                    </div>

                                                </ModalHeader>
                                                <ModalBody>
                                                    <div className="columns-container">
                                                        {PharmacyData.map((pharmacy, columnIndex) => {
                                                            const startNumber = columnIndex * 10 + 1;
                                                            return (
                                                                <div key={columnIndex} className="column" >
                                                                    {pharmacy.map((item, rowIndex) => (<>
                                                                        <div key={rowIndex} className="item-name">
                                                                            <span className="item-number">{`${startNumber + rowIndex}.`}</span>
                                                                            <span className="item-text">{item.phName}</span>
                                                                        </div>
                                                                    </>
                                                                    ))}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </ModalBody>
                                            </Modal>
                                        </div>
                                    </Col>
                                </>
                                }

                                {data.reportTypeID === 3 &&
                                    <>
                                        <Col md="3">
                                            <p className="m-0 f-14 mt-3 text-muted">Receiver ID</p>
                                            <p className="m-0 f-14 font-weight-500 mt-1">
                                                {data.receiverID}
                                            </p>
                                        </Col>
                                    </>

                                }
                                {data.reportTypeID === 4 &&
                                    <>
                                        <Col md="3">
                                            <p className="m-0 f-14 mt-3 text-muted">Trading Partner ID</p>
                                            <p className="m-0 f-14 font-weight-500 mt-1">
                                                {data.tradingPartnerID}
                                            </p>
                                        </Col>
                                    </>

                                }

                                <Col md="3">
                                    <p className="m-0 f-14 mt-3 text-muted">Start Date</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{dateFormate(data.startDate)}</p>
                                </Col>

                                <Col md="3">
                                    <p className="m-0 f-14 mt-3 text-muted">End date</p>
                                    {data.endDate !== null ?
                                        <p className="m-0 f-14 font-weight-500 mt-1">{dateFormate(data.endDate)}</p>
                                        :
                                        <p className="m-0 f-14 font-weight-500 mt-1 ">-</p>
                                    }
                                </Col>
                                {data.claimTypeDesc != "Replenished" &&
                                <Col md="3">
                                    <p className="m-0 f-14 mt-3 text-muted">Net Claims </p>
                                    <div className='d-flex justify-content-between align-items-center re_con'>
                                        <FormGroup switch style={{ paddingRight: "15px" }} className='view-Auto'>
                                            {data.netClaims == "Y" ?
                                                <Input
                                                    className='form-check-input'
                                                    type="switch"
                                                    checked={true}
                                                />
                                                :
                                                <Input
                                                    className='form-check-input'
                                                    type="switch"
                                                    checked={false}
                                                />

                                            }
                                        </FormGroup>
                                    </div>
                                </Col>
}
                            </Row>
                            <div className="d-flex justify-content-between section-devider-border">
                                <h4 className='f-15 text-primary font-weight-700 mt-4'>Report Settings</h4>
                            </div>
                            <Row>
                                {(data.reportTypeID == 1 || data.reportTypeID === 2 || data.reportTypeID == 5 || data.reportTypeID == 6) &&
                                    <Col md="12">
                                        <p className="m-0 f-14 mt-3 text-muted">Auto Send to ESP </p>
                                        <div className='d-flex justify-content-between align-items-center re_con'>
                                            <FormGroup switch style={{ paddingRight: "15px" }} className='view-Auto'>
                                                {data.autoSend == "Y" ?
                                                    <Input
                                                        className='form-check-input'
                                                        type="switch"
                                                        checked={true}
                                                    />
                                                    :
                                                    <Input
                                                        className='form-check-input'
                                                        type="switch"
                                                        checked={false}
                                                    />

                                                }
                                            </FormGroup>
                                        </div>
                                    </Col>
                                }
                                 {(data.reportTypeID == 7|| data.reportTypeID === 8) &&
                                    <Col md="12">
                                        <p className="m-0 f-14 mt-3 text-muted">Auto Send to Beacon </p>
                                        <div className='d-flex justify-content-between align-items-center re_con'>
                                            <FormGroup switch style={{ paddingRight: "15px" }} className='view-Auto'>
                                                {data.autoSend == "Y" ?
                                                    <Input
                                                        className='form-check-input'
                                                        type="switch"
                                                        checked={true}
                                                    />
                                                    :
                                                    <Input
                                                        className='form-check-input'
                                                        type="switch"
                                                        checked={false}
                                                    />

                                                }
                                            </FormGroup>
                                        </div>
                                    </Col>
                                }
                                
                                <Col md="12">
                                    <p className="m-0 f-14 mt-3 text-muted">Comments</p>
                                    {data.comments == '' ?
                                        <p className="m-0 f-14 font-weight-500 mt-1">-</p>
                                        :
                                        <p className="m-0 f-14 font-weight-500 mt-1">{data.comments}</p>
                                    }

                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </div>
            </Card>
            <div>
                <footer>
                    <div hidden={""}>
                        <Row>
                            <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                                <Button
                                    color="primary"
                                    className="reset"
                                    onClick={handleDiscard}
                                >

                                    Discard
                                </Button>

                            </Col>
                        </Row>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default ViewConfigurations;